export const DRAFT_TTL_MS = 7 * 24 * 60 * 60 * 1000;

export interface DraftScope {
  userId: number | null;
  companyId: number | null;
  savedAt: number | null;
}

interface Args {
  persisted: Partial<DraftScope> | null | undefined;
  current: Pick<DraftScope, "userId" | "companyId">;
  now: number;
}

/**
 * Decides whether a persisted order draft may be restored. A draft belongs to
 * exactly one user and one company, and dies after DRAFT_TTL_MS of not being
 * touched. Anything that fails this check is discarded, never merely hidden.
 */
export const isDraftRestorable = ({
  persisted,
  current,
  now,
}: Args): boolean => {
  if (!persisted) return false;

  const { userId, companyId, savedAt } = persisted;

  if (typeof userId !== "number" || typeof companyId !== "number") return false;
  if (typeof savedAt !== "number") return false;

  if (current.userId === null || current.companyId === null) return false;
  if (userId !== current.userId || companyId !== current.companyId)
    return false;

  return now - savedAt <= DRAFT_TTL_MS;
};
